export enum AvailableLanguagesEnum {
  FR = 'fr',
  EN = 'en',
  ES = 'es',
  IT = 'it',
  AR = 'ar',
}
